import AssetsManager from '../../../data/AssetsManager'

/**
 * SpaceViewクラス
 */
class SpaceView extends PIXI.Container {
  // ---------------------------------------------------------------------------------------------------------
  // --	SpaceView
  // ---------------------------------------------------------------------------------------------------------

  /**
   * コンストラクタ
   */
  constructor() {
    super()

    console.log('SpaceView')

    //コンフィグ
    this.config = AssetsManager.getConfig()

    //後ろのレイヤー
    this.backContainer = new PIXI.Container()
    this.addChild(this.backContainer)
    for(let i=0; i<2; i++)
    {
      const space = this.createSpace()
      space.y = - (this.config.STAGE_HEIGHT * 2) * i
      this.backContainer.addChild(space)
    }

    //前のレイヤー
    this.frontContainer = new PIXI.Container()
    this.addChild(this.frontContainer)
    for(let i=0; i<2; i++)
    {
      const space = this.createSpace()
      space.y = - (this.config.STAGE_HEIGHT * 2) * i
      this.frontContainer.addChild(space)
    }

    //リセット
    this.reset()
  }

  reset()
  {

  }

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 アップデート
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
  * アップデート
  */
  update(ship)
  {
    //速度
    const speedX = ship.shipSpeedX
    const speedY = ship.shipSpeedY

    //後ろの宇宙
    for(let i=0; i<2; i++)
    {
      const space = this.backContainer.getChildAt(i)
      space.y += speedY * 0.6
      space.x -= speedX * 0.6

      if(space.y >= this.config.STAGE_HEIGHT*2)
      {
        space.y -= (this.config.STAGE_HEIGHT*4)
      }
    }

    //前の宇宙
    for(let i=0; i<2; i++)
    {
      const space = this.frontContainer.getChildAt(i)
      space.y += speedY * 0.8
      space.x -= speedX * 0.8

      if(space.y >= this.config.STAGE_HEIGHT*2)
      {
        space.y -= (this.config.STAGE_HEIGHT*4)
      }
    }
  }
 

  // --------------------------------------------------------------------------------------------------------------------------------------
	// --	 生成
  // --------------------------------------------------------------------------------------------------------------------------------------

  /**
   * 宇宙生成
   */
  createSpace()
  {
    const space = new PIXI.Graphics()
    space.beginFill(0xFFFFFF)
    for(let i=0; i<100; i++)
    {
      const size = (Math.random()*50 < 0)?2:3
      const posX = -this.config.STAGE_WIDTH + Math.round(Math.random()*(this.config.STAGE_WIDTH*3))
      const posY = Math.round(Math.random()*(this.config.STAGE_HEIGHT*2))
      space.drawRect(posX, posY, size, size)
    }
    space.endFill()

    return space
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default SpaceView
